<template lang="html">
  <svg width="51px" height="51px" class="bigicon" :class="[iconType, {dark: darkmode}]" @click="$emit('click', $event)" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 51">
    <!-- AddProject -->
    <g v-if="icon === 'task'" key="task">
      <circle cx="25.5" cy="25.5" r="23" stroke="currentColor" stroke-width="3"/>
    </g>
    <g v-if="icon === 'done'" key="done">
      <circle cx="25.5" cy="25.5" r="23" stroke="#FFFFFF" stroke-width="3"/>
      <path d="M14 25.3333L23.3333 34.6667L37.3333 16" stroke="#FFFFFF" stroke-width="3" stroke-linejoin="round"/>
    </g>
    <g v-if="icon === 'timetracking'" key="timetracking">
      <path d="M45.5 5.87132C45.5 5.0429 44.8284 4.37132 44 4.37132H7C6.17157 4.37132 5.5 5.0429 5.5 5.87132C5.5 8.44075 6.0195 10.984 7.02781 13.3557C8.03607 15.7272 9.51282 17.8794 11.3718 19.6905C13.2307 21.5016 15.4353 22.9362 17.859 23.9142C20.2826 24.8923 22.8789 25.3952 25.5 25.3952C28.1211 25.3952 30.7174 24.8923 33.141 23.9142C35.5647 22.9362 37.7693 21.5016 39.6282 19.6905C41.4872 17.8794 42.9639 15.7272 43.9722 13.3557C44.9805 10.984 45.5 8.44075 45.5 5.87132Z" stroke="currentColor" stroke-width="3" stroke-linejoin="round"/>
      <path d="M5.5 44.8419C5.5 45.6703 6.17157 46.3419 7 46.3419L44 46.3419C44.8284 46.3419 45.5 45.6703 45.5 44.8419C45.5 42.2725 44.9805 39.7292 43.9722 37.3576C42.9639 34.986 41.4872 32.8338 39.6282 31.0227C37.7693 29.2117 35.5647 27.7771 33.141 26.799C30.7174 25.8209 28.1211 25.318 25.5 25.318C22.8789 25.318 20.2826 25.8209 17.859 26.799C15.4354 27.7771 13.2307 29.2117 11.3718 31.0227C9.51283 32.8338 8.03608 34.986 7.02781 37.3576C6.01951 39.7292 5.5 42.2725 5.5 44.8419Z" stroke="currentColor" stroke-width="3" stroke-linejoin="round"/>
    </g>
    <g v-if="icon === 'edit'" key="edit">
      <path d="M40.3744 4.96877C39.7886 4.38299 38.8388 4.38299 38.2531 4.96877L16.8449 26.3769C16.7065 26.5153 16.5965 26.6795 16.5212 26.8601L12.4735 36.5647C12.2394 37.1259 12.3673 37.7728 12.7972 38.2028C13.2272 38.6327 13.8741 38.7606 14.4353 38.5265L24.1399 34.4788C24.3205 34.4035 24.4847 34.2935 24.6231 34.1551L46.0312 12.7469C46.617 12.1612 46.617 11.2114 46.0312 10.6256L40.3744 4.96877Z" stroke="#FFFFFF" stroke-width="3" stroke-linejoin="round"/>
      <path d="M47 25.5V46C47 46.5523 46.5523 47 46 47H5C4.44772 47 4 46.5523 4 46V5C4 4.44772 4.44772 4 5 4H25.5" stroke="#FFFFFF" stroke-width="3"/>
    </g>
    <g v-if="icon === 'addProject'" key="addProject">
      <circle cx="25.5" cy="25.5" r="23" stroke="currentColor" stroke-width="3"/>
      <line x1="25.5" y1="13" x2="25.5" y2="38" stroke="#00FF96" stroke-width="3"/>
      <line x1="38" y1="25.5" x2="13" y2="25.5" stroke="#00FF96" stroke-width="3"/>
    </g>
</svg>
</template>

<script>
export default {
  props: {
    iconType: {
      type: String,
      default: 'normal',
    },
    icon: {
      type: String,
      default: 'task',
    },
    darkmode: {
      type: Boolean,
    },
  },
};
</script>

<style lang="stylus" scoped>
//schau obs da ist wenns da ist mach nichtzs und sonst lads runter
@require '../assets/styles/colors.styl'
@require '../assets/styles/styles.styl'
.icon
  &.positive
    color $positive

  &.normal
    color $normal

    &.dark
      color $darkmodeWhite
</style>
